module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-5-c3b9e53169ae3481e475aa2959338667.jpg";